import clsx from "clsx";

const SIZE_CLASSES = {
  md: "w-full px-3 py-2 text-sm focus:ring-2",
  sm: "px-2 py-1 text-sm focus:ring-1",
};

// Matches DESIGN.md's Inputs spec (Select shares Input's visual language).
export default function Select({ size = "md", className, children, ...props }) {
  return (
    <select
      className={clsx(
        "rounded-control border border-gray-300 bg-white dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 focus:outline-none focus:ring-brand",
        SIZE_CLASSES[size],
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
}
